import TopicSection from './topic-section'

export default TopicSection
